import { useState, useEffect, useCallback, useRef } from 'react';

import { Input, Button, Collapse, CheckboxGroup, Checkbox, Select } from '@douyinfe/semi-ui';
import { PageLayout } from '@/components/pagelay';
import Pagination from '@/components/seo-pagination';
import Link from 'next/link';

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import 'swiper/css'
import 'swiper/css/navigation';

import styles from './styles.module.scss';
import cName from 'classnames';

import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { getServerSideProps as _getServerSideProps, getHead } from '@/utils/useHead';
import request from '@/utils/request';

export async function getServerSideProps(context: any) {
  const res: any = await _getServerSideProps(context);
  const { data: _data1 } = await request.get(`/getCountryList`, {
    headers: {
      lang: context.locale || context.defaultLocale || 'cn',
    }
  })
  const { data: _data2 } = await request.get(`/getApplicationAreaList`, {
    headers: {
      lang: context.locale || context.defaultLocale || 'cn',
    }
  })
  const { data: _data3 } = await request.get(`/getExhibitorList`, {
    headers: {
      lang: context.locale || context.defaultLocale || 'cn',
    },
    params: {
      page: context.query.page || 1,
      limit: 15,
      company: context.query.company || "",
      category_ids: context.query.category_ids || "",
      country_id: context.query.country_id || "",
      application_area_ids: context.query.application_area_ids || "",
      letter: context.query.letter || "",
    }
  })
  return {
    props: {
      ...res.props,
      countryList: _data1?.data || null,
      fieldList: _data2?.data || null,
      data: _data3?.data || null,
    }
  }
}

interface IQuery {
  company?: string;
  category_ids?: string;
  country_id?: string;
  application_area_ids?: string;
  letter?: string;
}

export default function ExhibitorList({ menuDetail, countryList, fieldList, data }) {
  console.log("数据", menuDetail, countryList, fieldList, data);

  const router = useRouter()
  const t = useTranslations();

  const [selected, setSelected] = useState({
    company: "",
    country_id: "",
    category_ids: "",
    application_area_ids: "",
    letter: "",
  })

  const gotoPage = useCallback((query: any) => {
    query = {
      ...router.query,
      ...query,
    }
    for (let key in query) {
      if (!query[key]) {
        delete query[key];
      }
    }
    router.push(`${router.pathname}?${new URLSearchParams(query).toString()}`)
  }, [router])

  useEffect(() => {
    setSelected({
      company: (router.query.company as string) || "",
      country_id: (router.query.country_id as string) || "",
      category_ids: (router.query.category_ids as string) || "",
      application_area_ids: (router.query.application_area_ids as string) || "",
      letter: (router.query.letter as string) || "",
    })
  }, [router.query])

  return (
    <PageLayout temp='page_crumb'>
      <div className={styles.container}>
        {getHead(menuDetail)}
        <div className={cName(styles.content, 'm-1480')}>
          <div className={styles.top}>
            <p className={styles.title}>{t('online.title')}</p>
            <Input value={selected.company} placeholder={t('common.placeholder.company')}
              suffix={
                <Button className={styles.search}
                  onClick={() => {
                    gotoPage({
                      ...selected,
                      page: 1
                    })
                  }}
                >
                </Button>
              }
              onChange={(value) => {
                setSelected({
                  ...selected,
                  company: value,
                })
              }}
            />
          </div>
          <div className={styles.bottom}>
            <div className={styles.left}>
              <p className={styles.title}>{t('online.filter')}</p>
              <Collapse className={styles.item} defaultActiveKey={selected?.category_ids ? '1' : ''}>
                <Collapse.Panel header={t('online.filter1Place')} itemKey="1">
                  <CheckboxGroup value={selected?.category_ids ? selected?.category_ids.split(',')?.map((item: string) => Number(item)) : []} onChange={(checkedValue) => {
                    setSelected({
                      ...selected,
                      category_ids: checkedValue.join(','),
                    })
                  }}>
                    {
                      menuDetail?.list?.map((item: any, index: number) => (
                        <Checkbox key={index} value={item?.id}>{item?.[`name_${router.locale}`]}</Checkbox>
                      ))
                    }
                  </CheckboxGroup>
                </Collapse.Panel>
              </Collapse>
              <Select
                className={cName(styles.item, styles.select)}
                value={Number(selected?.country_id) || ''}
                showClear
                placeholder={t('online.filter2Place')}
                optionList={countryList?.map((item: any) => {
                  return {
                    label: item.name,
                    key: item.id,
                    value: item.id
                  }
                })}
                onChange={(value) => {
                  setSelected({
                    ...selected,
                    country_id: value as string,
                  })
                }}
              ></Select>
              <Collapse className={styles.item} defaultActiveKey={selected?.application_area_ids ? '1' : ''}>
                <Collapse.Panel header={t('online.filter3Place')} itemKey="1">
                  <CheckboxGroup value={selected?.application_area_ids ? selected?.application_area_ids.split(',')?.map((item: string) => Number(item)) : []} onChange={(checkedValue) => {
                    setSelected({
                      ...selected,
                      application_area_ids: checkedValue.join(','),
                    })
                  }}>
                    {
                      fieldList?.map((item: any, index: number) => (
                        <Checkbox key={index} value={item?.id}>{item?.[`name`]}</Checkbox>
                      ))
                    }
                  </CheckboxGroup>
                </Collapse.Panel>
              </Collapse>
              <Button className={cName(styles.item, styles.search)}
                onClick={() => {
                  gotoPage({
                    ...selected,
                    page: 1
                  })
                }}
              >
                {t('online.search')}
              </Button>
              <Link href="/visitor/purchase">
                <a className={cName(styles.item, styles.link)} target='_blank'>{t('online.purchase')}</a>
              </Link>
            </div>
            <div className={styles.right}>
              <div className={styles.letter}>
                <p className={styles.title}>{t('online.alph')}</p>
                <div className={styles.filter}>
                  <div className={cName(styles.prev, "swiper-button-prev")}></div>
                  <Swiper
                    className={cName(styles.swiper)}
                    modules={[Navigation]}
                    navigation={
                      {
                        prevEl: '.swiper-button-prev',
                        nextEl: '.swiper-button-next',
                      }
                    }
                    slidesPerView="auto"
                  >
                    <SwiperSlide>
                      <span
                        className={cName(styles.item, selected?.letter == "" && styles.active)}
                        style={{ borderLeft: 'none' }}
                        onClick={() => {
                          gotoPage({
                            ...selected,
                            letter: "",
                            page: 1
                          })
                        }}
                      >{t('online.all')}</span>
                    </SwiperSlide>
                    {
                      [...Array(26)]?.map((item: any, index: number) => {
                        let _letter = String.fromCharCode(65 + index);
                        return (
                          <SwiperSlide key={index}>
                            <span
                              className={cName(styles.item, selected?.letter === _letter ? styles.active : '')}
                              onClick={() => {
                                gotoPage({
                                  ...selected,
                                  letter: _letter,
                                  page: 1
                                })
                              }}
                            >
                              {_letter}
                            </span>
                          </SwiperSlide>
                        )
                      })
                    }
                  </Swiper>
                  <div className={cName(styles.next, "swiper-button-next")}></div>
                </div>
              </div>
              <ul className={styles.list}>
                {
                  data?.list?.map((item: any, index: number) => (
                    <li key={index}>
                      <Link href={`/online/exhibitor/info?id=${item?.id}`}>
                        <a className={styles.item}>
                          <div className={styles.cover}>
                            <img src={item.logo || 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} alt={item?.company} />
                          </div>
                          <div className={styles.info}>
                            <p className={styles.name}>{item?.company}</p>
                            <div className={styles.other}>
                              <p><span>{t('online.country')}</span>{item?.country}</p>
                              <p><span>{t('online.booth')}</span>{item?.booth_num}</p>
                              <p><span>{t('online.appliIndustry')}</span>{item?.[`application_area_${router.locale}`]}</p>
                            </div>
                          </div>
                          {
                            !!item.is_new && <img className={styles.new} src="http://admin.ipbexpo.com/uploads/editor/20250522/1d768871001222bd21322e845a7f2855.png" alt="" />
                          }
                        </a>
                      </Link>
                    </li>
                  ))
                }
              </ul>
              <div className={styles.pagination}>
                <Pagination
                  page={Number(router.query.page || 1)}
                  total={data?.total}
                  size={data?.per_page}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout >
  );
};